import * as createHexagon from './createHexagon';
import * as hexagonMath from './hexagonMath';

export {
  createHexagon,
  hexagonMath
};


/** WEBPACK FOOTER **
 ** ./src/extensions/hexagons/utils/index.js
 **/